export default "__VITE_ASSET__a139da60__"